
// scroll bar
import 'simplebar/src/simplebar.css';
import './utils/highlight';
// map
// import 'mapbox-gl/dist/mapbox-gl.css';
import './index.css'
// lightbox
import 'react-image-lightbox/style.css';

// editor
// import 'react-quill/dist/quill.snow.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// lazy image
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';


import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/lib/integration/react';

// redux
import App from './App';
import LoadingScreen from './components/LoadingScreen';
import I18nProvider from './components/I18nProvider';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import { AuthProvider } from './contexts/JWTContext';
import { SettingsProvider } from './contexts/SettingsContext';
import init from "./init";
import { persistor, store } from './redux/store';

if (import.meta.env.MODE === 'production') {

  console.log = () => { };
  console.error = () => { };
  console.debug = () => { };
}

// Suppress benign ResizeObserver errors
const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications.';
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes(resizeObserverLoopErr)) {
    return;
  }
  originalError(...args);
};

if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    if (e.message && (
      e.message.includes('ResizeObserver loop limit exceeded') ||
      e.message.includes('ResizeObserver loop completed with undelivered notifications')
    )) {
      e.stopImmediatePropagation();
    }
  });
}

ReactDOM.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <SettingsProvider>
          <I18nProvider>
            <CollapseDrawerProvider>
              <BrowserRouter>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </BrowserRouter>
            </CollapseDrawerProvider>
          </I18nProvider>
        </SettingsProvider>
      </PersistGate>
    </ReduxProvider>
  </HelmetProvider>,
  document.getElementById('root')
);

init();
